
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M13.955 1l4.5 4v14h-13.5v-3h1.5v1.5h10.5v-11h-4v-4h-6.5V7h-1.5V1h9zM8.881 8.5c.668 0 1.376.256 1.88.762l-.69.87c-.382-.287-.74-.443-1.19-.443-.427 0-.692.171-.692.482 0 .319.366.443.879.645l.722.288c.715.287 1.143.77 1.143 1.585 0 .964-.808 1.811-2.207 1.811-.754 0-1.563-.28-2.161-.832l.785-.956c.412.35.948.591 1.407.591.513 0 .754-.194.754-.505 0-.334-.32-.443-.816-.653l-.739-.31c-.606-.242-1.173-.747-1.173-1.586 0-.972.87-1.749 2.098-1.749zm-4.622 0c.754 0 1.36.35 1.757.754l-.731.886c-.288-.264-.59-.45-1.003-.45-.746 0-1.36.668-1.36 1.794 0 1.15.529 1.82 1.345 1.82.458 0 .831-.234 1.103-.53l.731.871c-.49.567-1.135.855-1.889.855-1.468 0-2.712-1.01-2.712-2.969C1.5 9.604 2.79 8.5 4.26 8.5zm8.402.109l.66 2.635c.171.621.28 1.22.451 1.85h.039c.163-.63.287-1.229.45-1.85l.654-2.635h1.414l-1.74 5.782h-1.664L11.192 8.61h1.469z"}})])
          )
        }
      }
    